import script from "./RidesSidebarDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RidesSidebarDetails.vue?vue&type=script&setup=true&lang=js"

import "./RidesSidebarDetails.vue?vue&type=style&index=0&id=3505a0da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3505a0da"]])

export default __exports__